import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import Skeleton from 'wsm-skeleton';

const LOADING_STATE_PLACEHOLDER_CARD_COUNT = 5;

const VehicleCardSkeleton = ({
	index,
	isGridLayout,
	isTabbedLayout,
	uuid,
	forwardedRef,
	placeholderImage
}) => {
	return (
		<li
			className={setClassNames([
				'box',
				'box-border',
				'vehicle-card',
				'vehicle-card-detailed',
				isGridLayout ? null : 'vehicle-card-horizontal horizontal'
			])}
			data-uuid={uuid}
			data-index={index}
			ref={forwardedRef}
		>
			<div
				className={setClassNames([
					'vehicle-card-body',
					'ddc-font-size-small',
					isGridLayout ? null : 'd-sm-flex flex-sm-row' // TODO: deprecate
				])}
			>
				<div className="vehicle-card-media-container m-0">
					<Skeleton
						skeletonClasses="mb-4"
						aspectRatio="4by3"
						placeholderImage={placeholderImage}
					/>
				</div>
				<div className="vehicle-card-details-container">
					<Skeleton
						skeletonClasses="mb-6"
						height="2rem"
						width={isTabbedLayout ? '100%' : '75%'}
					/>
					{[...Array(LOADING_STATE_PLACEHOLDER_CARD_COUNT)].map(
						(_, i) => (
							<div
								className="row"
								key={`skeleton_veh_${i.toString()}`}
							>
								<div className="col-xs-6">
									<Skeleton
										skeletonClasses="mb-5"
										height="1rem"
									/>
								</div>
								<div className="col-xs-6">
									<Skeleton
										skeletonClasses="mb-5"
										height="1rem"
									/>
								</div>
							</div>
						)
					)}
					{!isTabbedLayout && (
						<Skeleton
							skeletonClasses="ml-auto mt-6"
							width="48%"
							height="3rem"
						/>
					)}
				</div>
			</div>
			<div className="vehicle-card-footer p-0 mt-8">
				<Skeleton height="50px" />
			</div>
		</li>
	);
};

const WrappedVehicleCardSkeleton = React.forwardRef((props, ref) => {
	return <VehicleCardSkeleton {...props} forwardedRef={ref} />;
});

VehicleCardSkeleton.propTypes = {
	index: PropTypes.number,
	isGridLayout: PropTypes.bool.isRequired,
	isTabbedLayout: PropTypes.bool.isRequired,
	// only needed for substitution, not needed during initial load
	forwardedRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) })
	]),
	uuid: PropTypes.string,
	placeholderImage: PropTypes.string
};

VehicleCardSkeleton.defaultProps = {
	forwardedRef: null,
	uuid: undefined,
	index: undefined
};

export default WrappedVehicleCardSkeleton;
